import {
  FETCH_BEEPING_REPORT_SUCCESS,
  FETCH_BEEPING_REPORT_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  records: [],
  error: null,
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_BEEPING_REPORT_SUCCESS:
      return {
        ...state,
        error: null,
        records: action.payload,
      }

    case FETCH_BEEPING_REPORT_ERROR:
      return {
        ...state,
        records: [],
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
